import { render, staticRenderFns } from "./gross-assets.vue?vue&type=template&id=6b3ed8d2&scoped=true"
import script from "./gross-assets.vue?vue&type=script&lang=js"
export * from "./gross-assets.vue?vue&type=script&lang=js"
import style0 from "./gross-assets.vue?vue&type=style&index=0&id=6b3ed8d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ed8d2",
  null
  
)

export default component.exports